import React from "react";
import { useSelector } from "react-redux";
import styles from "./HeaderMenu.module.scss";
import { Link } from "react-router-dom";
import { ReactComponent as BellRinging } from "../../../assets/icons/bell-ringing.svg";
import { ReactComponent as ChartArrowsVertical } from "../../../assets/icons/chart-arrows-vertical.svg";
import { ReactComponent as Heart } from "../../../assets/icons/heart.svg";
import { ReactComponent as ShoppingBag } from "../../../assets/icons/shopping-bag.svg";
import { ReactComponent as UserCircle } from "../../../assets/icons/user-circle.svg";
import {
  selectCanViewAdminMarketplace,
  selectCanViewTransactions,
} from "../../../store/auth-slice";

const HeaderMenu = () => {
  const isMarketplaceAdmin = useSelector(selectCanViewAdminMarketplace);
  const canViewTransactions = useSelector(selectCanViewTransactions);
  return (
    <div className={styles.HeaderMenu}>
      <Link className={styles.MenuItem} to="/profile">
        <UserCircle className={styles.Icon} />
        Profil
      </Link>

      {isMarketplaceAdmin && (
        <Link className={styles.MenuItem} to="/admin-marketplace">
          <ChartArrowsVertical className={styles.Icon} />
          Pregled apoteka
        </Link>
      )}

      {!isMarketplaceAdmin && (
        <>
          <Link className={styles.MenuItem} to="/order-processing">
            <ShoppingBag className={styles.Icon} />
            Pregled porudžbina
          </Link>
          <Link className={styles.MenuItem} to="/rfzo-reminders">
            <BellRinging className={styles.Icon} />
            Podsetnici
          </Link>
          <Link className={styles.MenuItem} to="/patients">
            <Heart className={styles.Icon} />
            Omiljena apoteka
          </Link>
          {canViewTransactions && (
            <Link className={styles.MenuItem} to="/transactions">
              <ShoppingBag className={styles.Icon} />
              Transakcije
            </Link>
          )}
          <Link className={styles.MenuItem} to="/statistics">
            <ChartArrowsVertical className={styles.Icon} />
            Statistika
          </Link>
        </>
      )}
    </div>
  );
};

export default HeaderMenu;
